import useSocketStore from "./store";

export default useSocketStore;
